/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PostCalendarDto } from '../models/PostCalendarDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CalendarService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a Calendar
     * @param requestBody
     * @param xInstructorIndicator Indicator to scope the request to the instructor
     * @returns any
     * @throws ApiError
     */
    public calendarControllerCreateCalendarV1(
        requestBody: PostCalendarDto,
        xInstructorIndicator: string | null = 'true',
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/calendar',
            headers: {
                'x-instructor-indicator': xInstructorIndicator,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all Calendars
     * @param xInstructorIndicator Indicator to scope the request to the instructor
     * @returns any
     * @throws ApiError
     */
    public calendarControllerGetCalendarsV1(
        xInstructorIndicator: string | null = 'true',
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/calendar',
            headers: {
                'x-instructor-indicator': xInstructorIndicator,
            },
        });
    }
    /**
     * Get a Calendar
     * @param calendarId
     * @param xInstructorIndicator Indicator to scope the request to the instructor
     * @returns any
     * @throws ApiError
     */
    public calendarControllerGetCalendarV1(
        calendarId: string,
        xInstructorIndicator: string | null = 'true',
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/calendar/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
            headers: {
                'x-instructor-indicator': xInstructorIndicator,
            },
        });
    }
    /**
     * Archive a Calendar
     * @param calendarId
     * @param xInstructorIndicator Indicator to scope the request to the instructor
     * @returns any
     * @throws ApiError
     */
    public calendarControllerArchiveCalendarV1(
        calendarId: string,
        xInstructorIndicator: string | null = 'true',
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/calendar/{calendarId}/archive',
            path: {
                'calendarId': calendarId,
            },
            headers: {
                'x-instructor-indicator': xInstructorIndicator,
            },
        });
    }
}
